import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from '@mui/material';
import Stack from '@mui/material/Stack';
import { forwardRef } from 'react';
import { Icon } from '../../atoms/Icon/Icon';
import { Typography } from '../../atoms/Typography';
// TODO: use new design system tooltip here
import { Tooltip } from '../../legacy/components';
import { useTheme } from '../../theme';
export const IconList = forwardRef(function IconList({ iconVariant, text, tooltipDescription, iconSize = 'medium', textVariant = 'body1 light', }, ref) {
    const theme = useTheme();
    let color;
    if (iconVariant === 'check') {
        color = theme.palette.success.main;
    }
    if (iconVariant === 'close') {
        color = theme.palette.error.main;
    }
    if (iconVariant === 'circle') {
        color = theme.palette.groupPrimary.skyBlueAA;
    }
    return (_jsxs(Stack, { ref: ref, direction: "row", justifyContent: "space-between", alignItems: "center", spacing: 104, children: [_jsxs(Stack, { direction: "row", alignItems: "center", spacing: 104, children: [_jsx(Box, { color: color, children: _jsx(Icon, { variant: iconVariant, size: iconSize }) }), _jsx(Typography, { variant: textVariant, children: text })] }), !!tooltipDescription && _jsx(Tooltip, { description: tooltipDescription })] }));
});
